export {proxifiedFetch as fetch} from './proxifiedFetch';
